import { Grid, PasswordInput, TextInput } from "@mantine/core";

import { CallToAction } from "@/components/CallToAction";

interface SignInFormProps {
  signInForm: any;
}

export function SignInForm({ signInForm }: SignInFormProps) {
  return (
    <>
      <Grid.Col span={{ md: 12 }}>
        <TextInput
          withAsterisk
          label="Email"
          placeholder="Insira seu email"
          {...signInForm.getInputProps("email")}
        />
      </Grid.Col>
      <Grid.Col span={{ md: 12 }}>
        <PasswordInput
          withAsterisk
          label="Senha"
          placeholder="Insira sua senha"
          {...signInForm.getInputProps("password")}
        />
      </Grid.Col>

      <Grid.Col span={{ md: 12 }}>
        <CallToAction w="100%">Entrar</CallToAction>
      </Grid.Col>
    </>
  );
}
